<template>
  <div class="home">
    <!-- <nav class="navbar">
      <div class="navbar__left">
        <img
          alt="logo"
          src="../assets/logo_quick_pay_2022.png"
          style="margin: 0 auto"
        />
      </div>
      <div class="navbar__center">
        <ul>
          <li class="active" @click="changePage('/comercial')">Datos Comerciales</li>
          <li @click="changePage('/Incidencias')">Incidencias</li>
          <li @click="changePage('/InboxSugerences')">Buzón de sugerencias</li>
          <li @click="changePage('/ClientesB2C')">Clientes</li>
          <li @click="changePage('/UsuariosB2B')">Usuarios</li>
          <li @click="changePage('/Indicators/productos')">Indicadores</li>
          <li @click="changePage('/CargaArchivos')">Conciliación</li>
        </ul>
      </div>
      <div class="navbar__right">
        <div class="profile">
          <div class="profile__icon">
            <i class="far fa-user-circle"></i>
          </div>
          <div class="profile__detail">
            <p>{{ usuario }}</p>
            <span>{{ fecha }}</span>
          </div>
          <div @click="handleClick" class="profile__logout">
            <i class="fas fa-sign-out-alt"></i>
          </div>
        </div>
      </div>
    </nav> -->
    <Navbar :is-active="1"></Navbar>
    <div class="body">
      <div class="body__containt">
        <div class="page__title">
          <h2>Registros</h2>
        </div>
        <div class="page__filters">
          <input type="text" placeholder="RUC" v-model="company_ruc" @keyup="search"/>
          <input type="text" placeholder="Razón social" v-model="company_name" @keyup="search"/>

          <div style="display: flex; flex-direction:column; margin-top: -2rem;">
            <label >Fecha de Registro</label>
            <input type="date" v-model="fecha_register" @change="search"/>
          </div>
<!--          <input type="text" placeholder="Fecha de registro" />-->
          <select v-model="branch_status" @change="search">
            <option selected="selected" value="">Estado</option>
            <option value="1">Acivado</option>
            <option value="0">Desactivado</option>
          </select>
          <p @click="clean_filter()" class="clean_filter">Limpiar Filtros</p>

        </div>
        <br />
        <div class="page__buttons">
          <ButtonExport
            :data="companies"
            :columns="columns"
            :sheet-name="'Datos Socio Comercial'"
            :file-name="'Reporte Socio Comercial'"
          />
        </div>
        <div class="page__table">
          <div class="table-headers">
            <p v-for="{ label } of columns" :key="label">{{ label }}</p>
            <p>Acciones</p>
          </div>
          <div class="table-body">
            <div class="data" v-for="company of companies" :key="company.id">
              <p >{{ company.company_ruc }}</p>
              <p>{{ company.company_name }}</p>
              <p>{{ dateFormat(company.fecha) }}</p>
              <p>{{ company.group }}</p>
              <p>{{ company.type }}</p>
              <p>{{ company.customer }}</p>
              <p>{{ company.branches }}</p>
              <p>{{ company.connection }}</p>
              <p>{{ company.reconciliation }}</p>
              <p>
                {{
                  conditionalFormatValue(
                    company.company_status,
                    'Activo',
                    'Inactivo'
                  )
                }}
              </p>
              <div class="dropdown" >
                  <button class="button" @click="show('id-dropdown-content'+company.id)">
                    <i class="fa fa-ellipsis" style="color: red"></i>
                  </button>
                  <div @mouseleave="show('id-dropdown-content'+company.id)" class="dropdown-content" :id="'id-dropdown-content'+company.id">
                    <router-link :to="{ path: '/' }" @click="changeCompany(company.id, company.company_name)" class="dropdown-item">
                      <i class="far fa-eye " ></i> Ver Detalle
                    </router-link>     
                  </div>
              </div>
            </div>
            <div style="text-align: center;" v-if="empty">
              <h4 style="color: #938f8f; padding: 50px;">No se encontraron datos</h4>
            </div>
          </div>
        </div>
        <div class="page__pagination">
          <Pagination
              :data="pagination"
              v-on:changePage="handleClickInParent"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import ButtonExport from '@/components/ButtonExport.vue'
  import Dropdown from '@/components/Dropdown.vue'
  import { conditionalFormatValue } from '@/utils/formats'
  import Pagination from '@/components/Pagination.vue'
  import { dateFormat } from '@/utils/formats'
  import $ from 'jquery'
  import Navbar from '@/components/NavBar'

  export default {
    name: 'SocioComercial',
    components: {
      ButtonExport,
      Dropdown,
      Pagination,
      Navbar
    },
    data() {
      return {
        company_ruc: '',
        company_name: '',
        branch_status: '',
        type: 'SocioComercial',
        usuario: '',
        fecha: '',
        pagination: [],
        companies: [],
        fecha_register: '',   
        columns: [
          { label: 'Ruc', field: 'company_ruc' },
          { label: 'Razón Social', field: 'company_name' },
          { label: 'F. Registro', field: 'fecha' },
          { label: 'Grupo de negocio', field: 'group' },
          { label: 'Tipo de negocio', field: 'type' },
          { label: 'Tipo de cliente', field: 'customer' },
          { label: 'Cantidad de sucursales', field: 'branches' },
          { label: 'Conexión pasarela de pagos', field: 'connection' },
          { label: 'Tipo de reconcilación', field: 'reconciliation' },
          {
            label: 'Estado',
            field: 'company_status',
            dataFormat: value =>
              this.conditionalFormatValue(value, 'Activo', 'Inactivo')
          }
        ]
      }
    },
    methods: {
      changeCompany(companyId, companyName){
        localStorage.setItem('company_id', companyId)
        localStorage.setItem('company_name', companyName)
        localStorage.setItem('admin_in_company', '1')
      },
      clean_filter(){
      this.company_ruc = '';
      this.company_name = '';
      this.fecha_register = null;
      this.branch_status = '';
      this.getcompany();
      },
      dateFormat,
      handleClickInParent: function(page) {
        this.getcompany(page)
      },
      search: function() {
        clearTimeout(this.timeout);
        var self = this;
        this.timeout = setTimeout(function () {
          let paramSearch = {
            fecha_register: self.fecha_register,
            company_ruc: self.company_ruc,
            company_name: self.company_name,
            company_status: self.branch_status,
          }
          this.getcompany(1, paramSearch)
        }.bind(this), 500);
      },
      conditionalFormatValue,
      handleClick() {
        localStorage.removeItem('token')
        this.$router.push('/login')
      },
      zeroFill(number, width) {
        width -= number.toString().length
        if (width > 0) {
          return (
              new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number
          )
        }
        return number + ''
      },
      getDate() {
        let dias = [
          'Lunes',
          'Martes',
          'Miercoles',
          'Jueves',
          'Viernes',
          'Sabado',
          'Domingo'
        ]
        let meses = [
          'Enero',
          'Febrero',
          'Marzo',
          'Abril',
          'Mayo',
          'Junio',
          'Julio',
          'Agosto',
          'Septiembre',
          'Octubre',
          'Noviembre',
          'Diciembre'
        ]

        let date = new Date()

        const fechaNum = date.getDate()
        const mes_name = date.getMonth()

        let day = date.getDay() === 0 ? 6 : date.getDay() - 1
        this.fecha = dias[day] + ' ' + this.zeroFill(fechaNum, 2) + ' de ' + meses[mes_name]
      },
      show(divID){
        if (!$("body").hasClass("cerrarModal")){
          $('#'+divID).fadeIn();
          setTimeout(function () {
            $("body").addClass("cerrarModal");
          }, 10);
        }
      },
      changePage(url) {
        this.$router.push(url)
      },
      branchOffice() {
        this.$router.push('/branchoffice')
      },
      async getcompany(page = 1, paramSearch = {}) {
        await axios.get('general/company',{
          params: {
            page: page,
            ruc: paramSearch.company_ruc,
            name: paramSearch.company_name,
            state: paramSearch.company_status,
            fecha: paramSearch.fecha_register,
          },
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }}).then( res => {
          if (res.data.data.total > 0){
            this.companies = res.data.data.data
            this.pagination = res.data.data
            this.empty = false
          }else{
            this.companies = {}
            this.pagination = {}
            this.empty = true
          }
        })
      },
      deleteCompany(company_id) {
        this.$swal({
          title: '¿Estas seguro de eliminar al socio comercial?',
          text: '',
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Eliminar',
          cancelButtonText: 'Cancelar'
        }).then(result => {
          if (result.isConfirmed) {
            let result = axios
              .delete('general/company/' + company_id)
              .then(res => {
                if (res.data.success) {
                  this.$swal({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Se elimino correctamente',
                    showConfirmButton: false,
                    timer: 2000
                  })
                  this.$router.go(0)
                } else {
                  this.$swal({
                    position: 'top-end',
                    icon: 'error',
                    title: 'Ocurrio un problema',
                    showConfirmButton: false,
                    timer: 2000
                  })
                }
              })
          }
        })
      }
    },
    created() {
      localStorage.removeItem('admin_in_company')
      this.usuario = localStorage.getItem('usuario')
      this.getDate()
      this.getcompany()
    }
  }
</script>

<style scoped>
  /*------NAVBAR------*/
  .home {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    font-family: 'Readex Pro', sans-serif;
  }

  .home .navbar {
    width: 100%;
    height: 120px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: nowrap;
    align-items: center;
    border-bottom: 1px solid #dbdbdb;
    box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.05);
  }

  .home .navbar__left {
    width: 200px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .home .navbar__left img {
    width: 130px;
  }

  .home .navbar__center {
    width: 70%;
    height: 100%;
  }

  .home .navbar__center ul {
    width: 100%;
    height: 100%;
    display: flex;
    list-style: none;
    display: flex;
    justify-content: flex-start;
  }
  .home .navbar__center ul li {
    text-decoration: none;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 10px;
    position: relative;
    cursor: pointer;
  }

  .home .navbar__center ul li.active {
    color: #ff3128;
  }
  .home .navbar__center ul li.active::before {
    width: 100%;
  }

  .home .navbar__center ul li::before {
    content: '';
    position: absolute;
    bottom: 0;
    width: 0;
    height: 4px;
    background-color: #ff3128;
    transition: 0.3s ease;
  }
  .home .navbar__center ul li:hover {
    color: #ff3128;
  }
  .home .navbar__center ul li:hover::before {
    width: 100%;
  }

  .home .navbar__right {
    display: flex;
  }
  .home .navbar__right .profile {
    display: flex;
    width: 300px;
    height: 100%;
  }

  .home .navbar__right .profile__detail {
    width: 220px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 5px;
  }
  .home .navbar__right .profile__detail p {
    margin: 0;
  }
  .home .navbar__right .profile__detail span {
    color: #938f8f;
    font-weight: 300;
  }

  .home .navbar__right .profile__icon,
  .home .navbar__right .profile__logout {
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 25px;
    color: #ff3128;
    cursor: pointer;
  }
  /*------NAVBAR------*/

  /*-------------------------*/
  /*-------------------------*/

  /*------BODY------*/

  .body {
    width: 100%;
    height: 600px;
    display: flex;
  }
  .body__sidebar,
  .body__containt {
    height: calc(100vh - 120px);
    box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.1);
  }
  .body__sidebar {
    width: 400px;
    position: relative;
    display: flex;
    flex-direction: column;
  }

  .body__sidebar .floating-icon {
    position: absolute;
    right: -15px;
    top: 30px;
    color: #ff3128;
    font-size: 30px;
  }

  .body__sidebar .title {
    width: 100%;
    height: 140px;
    border-bottom: 1px solid #b6b6b6;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .body__sidebar .title__icon {
    color: #ff3128;
    font-size: 20px;
  }
  .body__sidebar .title__text {
    margin: 0 10px;
  }

  .body__sidebar .title__text h2 {
    font-size: 20px;
    margin: 0;
  }
  .body__sidebar .title__text p {
    margin: 0;
    font-weight: 300;
  }

  .body__sidebar .tabs {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: calc(100% - 140px);
    padding-top: 5px;
  }

  .body__sidebar .tabs .tab {
    width: 90%;
    height: 70px;
    border-radius: 10px;
    color: #707070;
    display: flex;
    align-items: center;
    padding: 0 20px;
    margin-bottom: 10px;
    cursor: pointer;
    transition: 0.3 ease;
  }
  .body__sidebar .tabs .tab:hover,
  .body__sidebar .tabs .tab.active {
    color: #ff3128;
    background: #ffeeed;
  }

  .body__sidebar .tabs .tab__icon {
    font-size: 20px;
    margin-right: 10px;
  }

  .body__sidebar .tabs .tab__text p {
    margin: 0;
    font-weight: 600;
  }

  .body__containt {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 20px 30px;
  }

  .body__containt .page__title {
    width: 100%;
    margin-bottom: 20px;
  }

  .body__containt .page__title h2 {
    font-weight: 600;
    color: #ff3128;
    font-size: 25px;
  }

  .body__containt .page__filters {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 20px;
  }
  .body__containt .page__filters input {
    border-radius: 10px;
    border: 1px solid #e4e4e4;
    background: #fff;
    padding: 15px 20px;
    /* margin: 0 10px; */
  }

  .body__containt .page__buttons {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 20px;
  }

  .body__containt .page__buttons .button {
    width: 250px;
    padding: 15px 20px;
    border-radius: 15px;
    font-size: 17px;
    color: #fff;
    border: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .body__containt .page__buttons .button:nth-child(1) {
    background: #000000;
  }
  .body__containt .page__buttons .button:nth-child(2) {
    background: #ff3128;
  }
  .body__containt .page__buttons .button:nth-child(3) {
    background: #262626;
  }

  .body__containt .page__table {
    width: 100%;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    margin-top: 50px;
  }

  .body__containt .page__table .table-headers {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    border-bottom: 1px solid #b6b6b6;
  }
  .body__containt .page__table .table-headers p {
    width: calc(100% / 7);
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    text-align: center;
  }

  .body__containt .page__table .table-body {
    width: 100%;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #b6b6b6;
  }

  .body__containt .page__table .table-body .data {
    width: 100%;
    display: flex;
  }
  .body__containt .page__table .table-body .data p {
    width: calc(100% / 7);
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 300;
    margin: 10px 0;
    text-align: center;
  }
  .body__containt .page__table .table-body .data p:nth-child(1) {
    color: #ff3128;
  }

  .page__filters select {
    border-radius: 10px;
    border: 1px solid #e4e4e4;
    background: #fff;
    padding: 15px 20px;
    /* margin: 0 10px; */
  }
  .page__filters input, select{
    outline:none;
    border: none;
    background: white;
  }

.dropdown-checkbox {
  display: none;
}

.dropdown-checkbox:checked + .wrapper {
  background-color: #32ba7c;
}

.dropdown-checkbox:checked + .wrapper > .circle {
  left: 15px;
}

.wrapper {
  width: 31px;
  height: 16px;
  cursor: pointer;
  margin-bottom: 0;
  margin-left: 1rem;
  position: relative;
  border-radius: 30px;
  background-color: #cbcbcb;
}

.circle {
  left: 0;
  width: 15px;
  height: 15px;
  transition: 0.2s;
  position: absolute;
  border-radius: 50%;
  background-color: #fff;
}
.button_delete{
  width: 2rem;
}
/*check*/
input[type="checkbox"] {
  width: 100%;
  height: 20px;
}
/*dropdown*/
.dropdown {
  display: flex;
  margin: 10px 0;
  font-weight: 300;
  position: relative;
  align-items: center;
  width: calc(100% / 7);
  justify-content: center;
}


.button {
  background: none;
  border: 0;
  color: inherit;
  outline:none;
}

.dropdown-item {
  height: 50px;
  display: flex;
  cursor: pointer;
  align-items: center;
}

.dropdown-item:active {
  color: inherit;
  background-color: inherit;
}

.dropdown-item svg {
  color: red;
  font-size: 1.2rem;
  margin-right: 0.8rem;
}

.dropdown-item-special {
  height: 60px;
  display: flex;
  padding: 1rem;
  font-weight: 400;
  align-items: center;
  justify-content: flex-end;
}

.dropdown-checkbox {
  display: none;
}

.dropdown-checkbox:checked + .wrapper {
  background-color: #32ba7c;
}

.dropdown-checkbox:checked + .wrapper > .circle {
  left: 15px;
}

.wrapper {
  width: 31px;
  height: 16px;
  cursor: pointer;
  margin-bottom: 0;
  margin-left: 1rem;
  position: relative;
  border-radius: 30px;
  background-color: #cbcbcb;
}

.circle {
  left: 0;
  width: 15px;
  height: 15px;
  transition: 0.2s;
  position: absolute;
  border-radius: 50%;
  background-color: #fff;
}
  /* .body__containt .page__filters input:nth-child(1) {
  width: 300px;
  margin: 0;
  margin-right: 10px;
} */

  /*------BODY------*/
  /* INICIO MOBILE*/
  @media (max-width: 768px){
    .body__containt .page__title h2{
      font-size: 21px;
    }
    .body__containt .page__filters input{
      padding: 5px 20px;
    }
    .page__filters select{
      padding: 10px 19px;
    }
    .body label{
      margin-top: 2rem;
      margin-left: 18px;
      font-size: 13px;
    }
    .body p.clean_filter{
      margin-top: 7px;
      font-size: 14px;

    }
    .buttonExport{
      margin-top: -13px;
      width: 179px;
      padding: 9px 20px;
    }
    .body__containt .page__table{
      font-size: 11px;
    }
    .body__containt .page__table .table-headers{
      margin-top: 6px;
      width: 245%;
    }
    .body__containt .page__table .table-body{
      width: 245%;
    }
  }
  /*FIN DE MOBILE*/


</style>
